import React, { useState } from 'react';
import { BRAND_GREEN, BRAND_GOLD } from '../theme/sucronTheme';
import { useSportsLang } from '../contexts/SportsLangContext';


export default function ContactPage() {
  const { lang } = useSportsLang();
  const LABELS = {
    pt: {
      heading: 'Entre em Contato',
      subtitle: 'Estamos aqui para ajudar! Envie sua mensagem e responderemos em breve.',
      formTitle: 'Envie sua Mensagem',
      nameLabel: 'Nome Completo *',
      namePlaceholder: 'Seu nome',
      emailLabel: 'E-mail *',
      emailPlaceholder: 'seu@email.com',
      categoryLabel: 'Categoria *',
      categories: [
        { value: 'geral', label: 'Dúvida Geral' },
        { value: 'dados', label: 'Questões sobre Dados/LGPD' },
        { value: 'privacidade', label: 'Privacidade e Consentimento' },
        { value: 'tecnico', label: 'Problema Técnico' },
        { value: 'sugestao', label: 'Sugestão de Melhoria' },
        { value: 'parceria', label: 'Parceria/Comercial' },
        { value: 'pesquisa', label: 'Pesquisa Acadêmica' },
        { value: 'outro', label: 'Outro' },
      ],
      subjectLabel: 'Assunto *',
      subjectPlaceholder: 'Resumo do assunto',
      messageLabel: 'Mensagem *',
      messagePlaceholder: 'Descreva sua dúvida, sugestão ou problema em detalhes...',
      sending: 'Enviando...',
      submit: 'Enviar Mensagem',
      privacyNote: 'Ao enviar esta mensagem, você concorda com nossa',
      privacyLink: 'Política de Privacidade',
      successTitle: 'Mensagem Enviada!',
      successText: 'Obrigado pelo contato. Retornaremos em até 48 horas.',
      errSend: 'Erro ao enviar mensagem. Tente novamente mais tarde.',
      channelsTitle: 'Outros Canais',
      genEmail: 'E-mail Geral',
      dpoTitle: 'Encarregado (DPO)',
      dpoDesc: 'Para questões de privacidade e LGPD',
      supportTitle: 'Suporte Técnico',
      faqTitle: 'Dúvidas Frequentes',
      faq: [
        { q: 'Quanto tempo leva para responder?', a: 'Respondemos em até 48 horas úteis. Questões de LGPD são priorizadas (até 15 dias).' },
        { q: 'Como uso meus dados em pesquisas?', a: 'Apenas dados anonimizados e com seu consentimento.', link: true },
        { q: 'Posso solicitar exclusão de dados?', a: 'Sim! Entre em contato com nosso DPO para exercer seus direitos LGPD.' },
      ],
      privacyBold: 'anonimizados',
      hoursTitle: 'Horário de Atendimento',
      hoursWeekdays: 'Segunda a Sexta:',
      hoursWeekdaysTime: '9h às 18h (Brasília)',
      hoursWeekend: 'Sábados, Domingos e Feriados:',
      hoursWeekendTime: 'Fechado',
      hoursNote: '* Mensagens recebidas fora do horário serão respondidas no próximo dia útil',
      aboutLink: 'Sobre Nós',
      aboutDesc: 'Conheça a Arena Stats',
      privacyPageLink: 'Privacidade',
      privacyPageDesc: 'Política de Privacidade e LGPD',
      termsLink: 'Termos de Uso',
      termsDesc: 'Regras e condições',
    },
    en: {
      heading: 'Contact Us',
      subtitle: "We're here to help! Send your message and we'll respond shortly.",
      formTitle: 'Send Your Message',
      nameLabel: 'Full Name *',
      namePlaceholder: 'Your name',
      emailLabel: 'E-mail *',
      emailPlaceholder: 'your@email.com',
      categoryLabel: 'Category *',
      categories: [
        { value: 'geral', label: 'General Inquiry' },
        { value: 'dados', label: 'Data / LGPD Questions' },
        { value: 'privacidade', label: 'Privacy & Consent' },
        { value: 'tecnico', label: 'Technical Issue' },
        { value: 'sugestao', label: 'Improvement Suggestion' },
        { value: 'parceria', label: 'Partnership / Commercial' },
        { value: 'pesquisa', label: 'Academic Research' },
        { value: 'outro', label: 'Other' },
      ],
      subjectLabel: 'Subject *',
      subjectPlaceholder: 'Brief summary',
      messageLabel: 'Message *',
      messagePlaceholder: 'Describe your question, suggestion or issue in detail...',
      sending: 'Sending...',
      submit: 'Send Message',
      privacyNote: 'By sending this message you agree to our',
      privacyLink: 'Privacy Policy',
      successTitle: 'Message Sent!',
      successText: 'Thank you for reaching out. We will respond within 48 hours.',
      errSend: 'Error sending message. Please try again later.',
      channelsTitle: 'Other Channels',
      genEmail: 'General E-mail',
      dpoTitle: 'Data Protection Officer (DPO)',
      dpoDesc: 'For privacy and LGPD matters',
      supportTitle: 'Technical Support',
      faqTitle: 'Frequently Asked Questions',
      faq: [
        { q: 'How long does it take to reply?', a: 'We reply within 48 business hours. LGPD matters are prioritized (up to 15 days).' },
        { q: 'How is my data used in research?', a: 'Only anonymized data and with your consent.', link: true },
        { q: 'Can I request data deletion?', a: 'Yes! Contact our DPO to exercise your LGPD rights.' },
      ],
      privacyBold: 'anonymized',
      hoursTitle: 'Business Hours',
      hoursWeekdays: 'Monday to Friday:',
      hoursWeekdaysTime: '9am to 6pm (Brasília time)',
      hoursWeekend: 'Weekends & Holidays:',
      hoursWeekendTime: 'Closed',
      hoursNote: '* Messages received outside business hours will be answered the next business day',
      aboutLink: 'About Us',
      aboutDesc: 'Learn about Arena Stats',
      privacyPageLink: 'Privacy',
      privacyPageDesc: 'Privacy Policy & LGPD',
      termsLink: 'Terms of Use',
      termsDesc: 'Rules and conditions',
    },
  };
  const T = LABELS[lang] || LABELS.pt;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    category: 'geral',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Enviar para API real
      // TODO: Migrate to AZURE instance from src/services/api.js when contact endpoint is ready
      const apiBase = window.ENV?.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'https://api-arenastats-d5bnakdcdbb8b5gw.brazilsouth-01.azurewebsites.net';
      const response = await fetch(`${apiBase}/api/contact/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao enviar mensagem');
      }

      console.log('[ContactPage] Mensagem enviada com sucesso:', data);
      setSubmitted(true);

      // Reset após 5 segundos
      setTimeout(() => {
        setSubmitted(false);
        setFormData({
          name: '',
          email: '',
          subject: '',
          category: 'geral',
          message: ''
        });
      }, 5000);

    } catch (error) {
      console.error('[ContactPage] Erro ao enviar:', error);
      alert(T.errSend);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
          {T.heading}
        </h1>
        <p className="text-lg text-gray-600">
          {T.subtitle}
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        {/* Formulário de Contato */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" 
                     style={{ backgroundColor: 'var(--brand-green-light)' }}>
                  <svg className="w-8 h-8" style={{ color: BRAND_GREEN }} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold mb-2" style={{ color: BRAND_GREEN }}>
                  {T.successTitle}
                </h3>
                <p className="text-gray-600">
                  {T.successText}
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
                  {T.formTitle}
                </h2>

                {/* Nome */}
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                    {T.nameLabel}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2"
                    style={{ borderColor: 'var(--brand-border)' }}
                    placeholder={T.namePlaceholder}
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    {T.emailLabel}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2"
                    style={{ borderColor: 'var(--brand-border)' }}
                    placeholder={T.emailPlaceholder}
                  />
                </div>

                {/* Categoria */}
                <div>
                  <label htmlFor="category" className="block text-sm font-semibold text-gray-700 mb-2">
                    {T.categoryLabel}
                  </label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2"
                    style={{ borderColor: 'var(--brand-border)', color: BRAND_GREEN }}
                  >
                    {T.categories.map((c) => (
                      <option key={c.value} value={c.value}>{c.label}</option>
                    ))}
                  </select>
                </div>

                {/* Assunto */}
                <div>
                  <label htmlFor="subject" className="block text-sm font-semibold text-gray-700 mb-2">
                    {T.subjectLabel}
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2"
                    style={{ borderColor: 'var(--brand-border)' }}
                    placeholder={T.subjectPlaceholder}
                  />
                </div>

                {/* Mensagem */}
                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                    {T.messageLabel}
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 resize-none"
                    style={{ borderColor: 'var(--brand-border)' }}
                    placeholder={T.messagePlaceholder}
                  />
                </div>

                {/* Botão Enviar */}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full px-6 py-4 rounded-lg font-bold text-white transition-all hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ backgroundColor: BRAND_GREEN }}
                >
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                        {T.sending}
                      </span>
                    ) : (
                      T.submit
                  )}
                </button>

                <p className="text-xs text-gray-500 text-center">
                  {T.privacyNote}{' '}
                  <a href="/privacidade" className="underline" style={{ color: BRAND_GREEN }}>
                    {T.privacyLink}
                  </a>
                  .
                </p>
              </form>
            )}
          </div>
        </div>

        {/* Informações de Contato */}
        <div className="space-y-6">
          {/* Canais de Contato */}
          <div className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
            <h3 className="text-xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
              {T.channelsTitle}
            </h3>
            
            <div className="space-y-4">
              {/* Email Geral */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ backgroundColor: 'var(--brand-green-light)' }}>
                  <svg className="w-5 h-5" style={{ color: BRAND_GREEN }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{T.genEmail}</h4>
                  <a href="mailto:contato@vukz.ai" 
                     className="text-sm hover:underline" 
                     style={{ color: BRAND_GREEN }}>
                    contato@vukz.ai
                  </a>
                </div>
              </div>

              {/* DPO */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ backgroundColor: 'var(--brand-gold-light)' }}>
                  <svg className="w-5 h-5" style={{ color: BRAND_GOLD }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{T.dpoTitle}</h4>
                  <p className="text-sm text-gray-600 mb-1">
                    {T.dpoDesc}
                  </p>
                  <a href="mailto:dpo@vukz.ai" 
                     className="text-sm hover:underline" 
                     style={{ color: BRAND_GOLD }}>
                    dpo@vukz.ai
                  </a>
                </div>
              </div>

              {/* Suporte Técnico */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" 
                     style={{ backgroundColor: 'var(--brand-green-light)' }}>
                  <svg className="w-5 h-5" style={{ color: BRAND_GREEN }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{T.supportTitle}</h4>
                  <a href="mailto:suporte@vukz.ai" 
                     className="text-sm hover:underline" 
                     style={{ color: BRAND_GREEN }}>
                    suporte@vukz.ai
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div className="bg-green-50 rounded-xl border-2 p-6" style={{ borderColor: BRAND_GREEN }}>
            <h3 className="text-xl font-bold mb-3" style={{ color: BRAND_GREEN }}>
              {T.faqTitle}
            </h3>
            <div className="space-y-3 text-sm">
              {T.faq.map((item, i) => (
                <div key={i}>
                  <p className="font-semibold text-gray-900 mb-1">{item.q}</p>
                  <p className="text-gray-700">
                    {item.link ? (
                      <>
                        {lang === 'en' ? 'Only ' : 'Apenas dados '}
                        <strong>{T.privacyBold}</strong>
                        {lang === 'en' ? ' data and with your consent. See our ' : ' e com seu consentimento. Consulte nossa '}
                        <a href="/privacidade" className="underline" style={{ color: BRAND_GREEN }}>
                          {T.privacyLink}
                        </a>.
                      </>
                    ) : item.a}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Horário */}
          <div className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
            <h3 className="text-xl font-bold mb-3" style={{ color: BRAND_GREEN }}>
              {T.hoursTitle}
            </h3>
            <div className="space-y-2 text-sm text-gray-700">
              <p><strong>{T.hoursWeekdays}</strong> {T.hoursWeekdaysTime}</p>
              <p><strong>{T.hoursWeekend}</strong> {T.hoursWeekendTime}</p>
              <p className="text-xs text-gray-500 mt-3">{T.hoursNote}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Links Relacionados */}
      <div className="mt-12 grid md:grid-cols-3 gap-4">
        <a href="/sobre" className="block p-6 bg-white rounded-xl border-2 hover:shadow-lg transition-all text-center" style={{ borderColor: 'var(--brand-border)' }}>
          <svg className="w-8 h-8 mx-auto mb-3" style={{ color: BRAND_GREEN }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h4 className="font-bold mb-1" style={{ color: BRAND_GREEN }}>{T.aboutLink}</h4>
          <p className="text-sm text-gray-600">{T.aboutDesc}</p>
        </a>
        <a href="/privacidade" className="block p-6 bg-white rounded-xl border-2 hover:shadow-lg transition-all text-center" style={{ borderColor: 'var(--brand-border)' }}>
          <svg className="w-8 h-8 mx-auto mb-3" style={{ color: BRAND_GREEN }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <h4 className="font-bold mb-1" style={{ color: BRAND_GREEN }}>{T.privacyPageLink}</h4>
          <p className="text-sm text-gray-600">{T.privacyPageDesc}</p>
        </a>
        <a href="/termos" className="block p-6 bg-white rounded-xl border-2 hover:shadow-lg transition-all text-center" style={{ borderColor: 'var(--brand-border)' }}>
          <svg className="w-8 h-8 mx-auto mb-3" style={{ color: BRAND_GREEN }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h4 className="font-bold mb-1" style={{ color: BRAND_GREEN }}>{T.termsLink}</h4>
          <p className="text-sm text-gray-600">{T.termsDesc}</p>
        </a>
      </div>
    </div>
  );
}
